import { render, staticRenderFns } from "./SegDocumento.vue?vue&type=template&id=1ddd8c48&scoped=true&"
import script from "./SegDocumento.vue?vue&type=script&lang=js&"
export * from "./SegDocumento.vue?vue&type=script&lang=js&"
import style0 from "./SegDocumento.vue?vue&type=style&index=0&id=1ddd8c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd8c48",
  null
  
)

export default component.exports